/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StockReceipt } from '../../models/stock-receipt';

export interface StockReceiptsControllerCancel$Params {
  id: string;
}

export function stockReceiptsControllerCancel(http: HttpClient, rootUrl: string, params: StockReceiptsControllerCancel$Params, context?: HttpContext): Observable<StrictHttpResponse<StockReceipt>> {
  const rb = new RequestBuilder(rootUrl, stockReceiptsControllerCancel.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StockReceipt>;
    })
  );
}

stockReceiptsControllerCancel.PATH = '/stock/receipts/{id}/cancel';
